<template lang="pug">
  r-table(
    no-filter
    no-search
    ref='table'
    v-bind='tableProps'
    @detail='submitUpdate'
    @remove='submitDelete'
    )
</template>

<script>
  //
  import { RTable } from '@/components/reusable_components/next'
  //
  import GBankHeaders from '@/views/General/GBank/GBankHeaders'
  import GBankModel from '@/models/General/GBank'
  //
  export default {
    components: {
      RTable,
    },
    computed: {
      tableProps() {
        return {
          headers: GBankHeaders,
          service: GBankModel,
        }
      }
    },
    data() {
      return {
        selected: null,
      }
    },
    methods: {
      showDeleteError() {
        this.$toast.error('Error al eliminar banco.')
      },
      showDeleteSuccess() {
        this.$toast.success('Banco eliminada exitosamente.')
      },
      submitCreate() {
        this.$router.push({ name: 'g-bank-create' })
      },
      submitDelete(event) {
        this.selected = event.item
        this.$toast.confirm("¿Confirma la eliminación de la banco seleccionada?", this.$toaster(this, this.toDelete))
      },
      submitUpdate(event) {
        this.$router.push({ name: 'g-bank-update', params: { id: event.item.id } })
      },
      toDelete() {
        return this
          .selected
          .delete()
          .then(this.showDeleteSuccess)
          .then(this.toRefresh)
          .catch(this.showDeleteError)
      },
      toRefresh() {
        return this
          .$refs
          .table
          .refresh()
      }
    },
    created() {
      this.setTitle('Bancos')
      this.setItems([
        {
          action: this.submitCreate,
          color: 'accent',
          text: 'banco',
          icon: 'add_circle',
        },
      ])
    },
  }
</script>